import {Box, HBox} from '@buncha/components/core/view';
import {CustomText, PSmallText} from '@buncha/components/core/text';
import {useColorThemeType, useFontTheme} from '@buncha/appStyles/hooks/theme';

import {CustomImage} from '@buncha/components/core/Image';
import React from 'react';
import {styles} from './styles';

interface FailedOrderItemProps {
  leftComponent?: React.ReactNode;
  itemName: string;
  subText: string;
  itemImage: string;
}

const FailedOrderItem: React.FC<FailedOrderItemProps> = props => {
  const {leftComponent, itemName, subText, itemImage} = props;
  const theme = useColorThemeType();
  const muliFont = useFontTheme('muli');
  return (
    <HBox>
      <HBox style={styles.flexStyle}>
        <CustomImage style={styles.imageStyle} source={itemImage} />
        <Box style={styles.textContainer}>
          <CustomText
            style={[
              styles.itemText,
              styles.flexStyle,
              {
                fontFamily: muliFont[700].normal,
                color: theme?.text.blue[300],
              },
            ]}
            numberOfLines={1}>
            {itemName}
          </CustomText>
          <PSmallText
            style={[
              styles.subText,
              styles.flexStyle,
              {
                fontFamily: muliFont[700].normal,
                color: theme?.text.gray[100],
              },
            ]}
            numberOfLines={2}>
            {subText}
          </PSmallText>
        </Box>
      </HBox>
      {leftComponent}
    </HBox>
  );
};

export default React.memo(FailedOrderItem);
